import { render, staticRenderFns } from "./formattedNumberInput.vue?vue&type=template&id=83726716&lang=pug"
import script from "./formattedNumberInput.vue?vue&type=script&lang=js"
export * from "./formattedNumberInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports